import { Facet } from '../models/Facet';
import { IItemCacheDispatch, IItemCacheThunkAction } from '../store/actions/ItemCacheActions';
import { IItemCache } from '../models/IItemCacheObserver';
import { KeyFacet } from '../models/KeyFacet';
import { resolveItems } from './getItems';

export const blockItemPageKeyFacet = new KeyFacet<{}>('blockItemPageKey', {});
export const blockItemPageFacet = new Facet<boolean>('blockItemPage');

function blockItemPageInternal(value: boolean): IItemCacheThunkAction<void> {
    return (dispatch: IItemCacheDispatch) => {
        const blockItemPageKey = blockItemPageKeyFacet.serialize({});
        dispatch(resolveItems({
            items: {
                [blockItemPageKey]: { ...blockItemPageFacet.pack(value) }
            }
        }));
    };
}

export function blockItemPage(): IItemCacheThunkAction<void> {
    return blockItemPageInternal(true);
}

export function unblockItemPage(): IItemCacheThunkAction<void> {
    return blockItemPageInternal(false);
}

export function itemPageIsBlocked(itemCache: IItemCache): boolean | undefined {
    const blockItemPageKey = blockItemPageKeyFacet.serialize({});
    return itemCache.demandItemFacet(blockItemPageFacet, blockItemPageKey);
}
